import React from 'react';

const FormattedFaxNumber = (props) => {

  const {
    faxNumber,
    useUpdatedLibPhoneNumberLibrary,
  } = props;

  const formattedFaxNumber = hellofaxJS.formatInternationalFaxNumber(
    faxNumber, useUpdatedLibPhoneNumberLibrary,
  );

  return <span className="fax-number">{formattedFaxNumber}</span>;

};

export default FormattedFaxNumber;
